require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-update-مجموعات-متضررة-تقدم-شكوى-ضد-مصنع-للاسمنت-في-مصر-تموله.json") })
        }
      }, "path---ar-eg-update-مجموعات-متضررة-تقدم-شكوى-ضد-مصنع-للاسمنت-في-مصر-تموله");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-update-مجموعات-متضررة-تقدم-شكوى-ضد-مصنع-للاسمنت-في-مصر-تموله!./.cache/json/ar-eg-update-مجموعات-متضررة-تقدم-شكوى-ضد-مصنع-للاسمنت-في-مصر-تموله.json
// module id = 462
// module chunks = 231608221292675